import { render, staticRenderFns } from "./BookExtra.vue?vue&type=template&id=54d37b5e&scoped=true&"
import script from "./BookExtra.vue?vue&type=script&lang=ts&"
export * from "./BookExtra.vue?vue&type=script&lang=ts&"
import style0 from "./BookExtra.vue?vue&type=style&index=0&id=54d37b5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d37b5e",
  null
  
)

export default component.exports